import UploadForm from './upload_form';

export default UploadForm;
